import React from 'react';
import { AssetsMap } from './assets';
import { SpinnerBox, SpinnerAnimate } from './spinner.styles';
export function Spinner(props) {
  const {
    boxRef,
    size,
    ...rest
  } = props;
  const Icon = AssetsMap[size];
  if (!Icon) {
    console.error(`[Spinner]: incorrect size: ${size}!`);
    return null;
  }
  return React.createElement(SpinnerBox, {
    ...rest,
    size: size,
    ref: boxRef
  }, React.createElement(SpinnerAnimate, null, React.createElement(Icon, null)));
}